module.exports = __webpack_public_path__ + "img/clock.2e662dcb.svg";